import React from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Layout from "../../components/Layout.tsx";
import Title from "../../components/Title.tsx";
import Button from "../../components/Button.tsx";
import { createRole, roleApiError } from "../../services/role.service.js";
import { notification } from "../../utils/Notifications.tsx";
import { can } from "../../auth/can.ts";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";

const NewRole = () => {
  useAppSettings();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!can("roles.create", user)) {
      navigate("/roles");
    }
  }, [user, navigate]);

  const formik = useFormik({
    initialValues: { name: "", code: "", description: "" },
    validate: (values) => {
      const errors: Record<string, string> = {};
      if (!values.name.trim()) errors.name = "Obligatorio";
      if (!values.code.trim()) errors.code = "Obligatorio";
      else if (!/^[a-z][a-z0-9_]{1,47}$/.test(values.code.trim().toLowerCase())) {
        errors.code = "snake_case ASCII en minúsculas";
      }
      return errors;
    },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await createRole({
          name: values.name.trim(),
          code: values.code.trim().toLowerCase(),
          description: values.description.trim(),
        });
        notification("Éxito", "Rol creado", "success");
        navigate("/roles");
      } catch (error) {
        notification("Error", roleApiError(error), "danger");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Layout loading={loading}>
      <Title
        baseTitle="Roles"
        basePath="/roles"
        activeTitle="Nuevo"
        title="Nuevo rol personalizado"
      />
      <div className="card border-0 m-4 p-4">
        <div className="mb-3">
          <label className="form-label">Nombre</label>
          <input
            className="form-control"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
          {formik.errors.name && (
            <div className="text-danger fs-12px">{formik.errors.name}</div>
          )}
        </div>
        <div className="mb-3">
          <label className="form-label">Code</label>
          <input
            className="form-control"
            name="code"
            value={formik.values.code}
            onChange={formik.handleChange}
            placeholder="supervisor_regional"
          />
          {formik.errors.code && (
            <div className="text-danger fs-12px">{formik.errors.code}</div>
          )}
        </div>
        <div className="mb-3">
          <label className="form-label">Descripción</label>
          <textarea
            className="form-control"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
          />
        </div>
        <div className="row justify-content-end">
          <div className="col-md-3">
            <Button
              type="button"
              variant="secondary"
              title="Cancelar"
              onClick={() => navigate("/roles")}
            />
          </div>
          <div className="col-md-3">
            <Button
              type="submit"
              variant="azul"
              title="Guardar"
              onClick={() => formik.handleSubmit()}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NewRole;
